import { connect } from 'react-redux'
import { setTagAmount } from 'actions/campaigns/elements_selector_actions'
// import { createLoadingSelector } from 'libs/requests_status_handlers'

// const loadingSelector = createLoadingSelector([types.CREATE_ELEMENT])

export default connect((state) => ({
  allTags: state.campaigns?.tags || [],
}), { setTagAmount })
